import React from 'react';
import NewDialog from './NewDialog';

export interface IBasicDialog {
  showCancel: boolean;
  content: string | React.ReactNode;
  title: string;
  onOk?: () => any;
  onCancel?: () => void;
  show: boolean;
  okText?: string;
  cancelText?: string;
  wrapClassName?: string;
}

export default class BasicDialog extends React.Component<IBasicDialog, any> {
  render() {
    const {
      showCancel,
      content,
      title,
      onOk,
      onCancel,
      show,
      okText,
      cancelText,
      wrapClassName
    } = this.props;
    return show ? (
      <NewDialog
        showCancel={showCancel}
        onOk={onOk}
        onCancel={onCancel}
        okText={okText}
        cancelText={cancelText}
        wrapClassName={wrapClassName}
      >
        <div className="title">{title}</div>
        {content}
      </NewDialog>
    ) : null;
  }
}
